import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';

import Back from './Back';
import Front from './Front';

const { bool, string } = PropTypes;

if (process.env.NODE_ENV !== 'test') {
  require('./Flipper.scss');
}

export default class Flipper extends Component {
  static propTypes = {
    orientation: string.isRequired,
    flipped: bool.isRequired,
    children: function(props, propName, componentName) {
      const firstChild = props[propName][0];
      const secondChild = props[propName][1];

      if (
        // Length of one allowed as long as first component is <Front>
        (props[propName].length === 1 && firstChild.type.name !== 'Front') ||
        // Length of two allowed as long as first child is <Front> and second child is <Back>
        (props[propName].length === 2 &&
          (firstChild.type.name !== 'Front' ||
            secondChild.type.name !== 'Back')) ||
        // All other children not allowed
        props[propName].length > 2 ||
        props[propName].length < 1
      ) {
        return new Error(
          `Invalid children supplied to \`${componentName}\`,` +
            'expected shape `[Front, Back]`.',
        );
      }

      return null;
    },
  };

  static defaultProps = {
    orientation: 'horizontal',
  };

  render() {
    const { orientation, flipped } = this.props;
    return (
      <div className={classNames('flipper-container', orientation)}>
        <div className={classNames('flipper', { flipped })}>
          {this.props.children}
        </div>
      </div>
    );
  }
}

export { Flipper, Front, Back };
